export default __webpack_public_path__ + "static/media/background.f6b4d832.jpg";